<template>
  <div id="Manager" class="fullheight">
    <eco-table
      @load="loadData"
      :data="budget_manager"
      :pageResult="pageResult"
      :selection="false"
      :show-export="false"
      :show-custom-column="false"
      ref="ecoTable"
    >
      <template>
        <eco-table-column prop="type_key" label="数据开关" :formatter="changeKey" :show-overflow-tooltip="true"> </eco-table-column>
        <eco-table-column prop="desc" label="功能说明" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.desc ? scope.row.desc : '新增客户时，只有创建人和默认范围的用户可以查看，其它用户需要指定后才可以查看。' }}
          </template>
        </eco-table-column>
        <eco-table-column prop="status" label="是否开启" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-switch
              @change="switchClick(scope.row)"
              v-model="scope.row.F_is_open"
              :disabled="scope.row.F_is_open == 1 && scope.row.type_key === 'calculation_of_construction_project_taxes'"
            >
            </el-switch>
          </template>
        </eco-table-column>
        <eco-table-column label="默认可见范围">
          <template slot-scope="scope">
            <eip-user-selector
              v-if="scope.row.type_key === 'custom'"
              v-model="scope.row.F_default_user"
              placeholder="选择用户"
              :single="false"
              :appendToBody="true"
              @input="(params) => valueChange(params, scope.row)"
              style="overflow: hidden"
            >
            </eip-user-selector>
            <el-popover placement="bottom" width="200" trigger="click">
              <el-table :data="gnData">
                <el-table-column property="name" label="功能名称"></el-table-column>
              </el-table>
              <el-link type="primary" :underline="false" slot="reference" v-show="scope.row.type_key == 'joint_management' && scope.row.F_is_open">
                查看功能菜单
              </el-link>
            </el-popover>
            <el-popover placement="bottom" width="200" trigger="click">
              <el-table :data="pcData">
                <el-table-column property="name" label="功能名称"></el-table-column>
              </el-table>
              <el-link type="primary" :underline="false" slot="reference" v-show="scope.row.type_key == 'parent_child_project' && scope.row.F_is_open">
                查看功能菜单
              </el-link>
            </el-popover>
            <!-- 施工项目税金计算 -->
            <el-link
              type="primary"
              :underline="false"
              slot="reference"
              v-if="scope.row.type_key === 'calculation_of_construction_project_taxes' && scope.row.F_is_open"
              @click="customProjectTaxes(scope.row)"
            >
              编辑
            </el-link>
            <!-- 设计项目税金计算 -->
            <el-link
              type="primary"
              :underline="false"
              slot="reference"
              v-if="scope.row.type_key === 'calculation_of_design_project_taxes' && scope.row.F_is_open"
              @click="customDesignTaxes(scope.row)"
            >
              编辑
            </el-link>
            <!-- 有权应收款 -->
            <el-link
              type="primary"
              :underline="false"
              slot="reference"
              v-if="scope.row.type_key === 'receivable_calculation' && scope.row.F_is_open"
              @click="customReceivables(scope.row)"
            >
              编辑
            </el-link>
            <!-- 仓库存货核算 -->
            <el-link
              type="primary"
              :underline="false"
              slot="reference"
              v-if="scope.row.type_key === 'warehouse_inventory_accounting' && scope.row.F_is_open"
              @click="customWarehouse(scope.row)"
            >
              编辑
            </el-link>
            <!-- 仓库存货核算 -->
            <el-link
              type="primary"
              :underline="false"
              slot="reference"
              v-if="scope.row.type_key === 'bill_management' && scope.row.F_is_open"
              @click="customBillManagement(scope.row)"
            >
              编辑
            </el-link>
            <!-- 施工人员动态必配职位 -->
            <el-link
              type="primary"
              :underline="false"
              slot="reference"
              v-if="scope.row.type_key === 'construction_personnel' && scope.row.F_is_open"
              @click="customConstructionPersonnel(scope.row)"
            >
              编辑
            </el-link>
            <!-- 营销跟踪数控制 -->
            <el-link
              type="primary"
              :underline="false"
              slot="reference"
              v-if="scope.row.type_key === 'track_num' && scope.row.F_is_open"
              @click="customTrackNumFunc(scope.row)"
            >
              编辑
            </el-link>
            <!-- 集采材料控制 -->
            <el-link
              type="primary"
              :underline="false"
              slot="reference"
              v-if="scope.row.type_key === 'concentrate_apply_material_is_purchase' && scope.row.F_is_open"
              @click="customMaterialControlFunc(scope.row)"
            >
              编辑
            </el-link>
            <!-- 项目部考核 -->
            <el-link
              type="primary"
              :underline="false"
              slot="reference"
              v-if="scope.row.type_key === 'project_department_assessment' && scope.row.F_is_open"
              @click="customProjectDepartmentAssessmentControlFunc(scope.row)"
            >
              编辑
            </el-link>
            <!-- 成本合同付款控制比例 -->
            <el-link
              type="primary"
              :underline="false"
              slot="reference"
              v-if="scope.row.type_key === 'cost_pay_ratio_control' && scope.row.F_is_open"
              @click="customCostPayRatioControlFunc(scope.row)"
            >
              编辑
            </el-link>
          </template>
        </eco-table-column>
      </template>
    </eco-table>
    <projectTaxes ref="projectTaxes" :noticeData="noticeData" :isEdit="isEdit" :show="show" @close="close"></projectTaxes>
    <designTaxes ref="designTaxes" :noticeData="noticeData" :isEdit="isEdit" :show="show1" @close="close"></designTaxes>
    <warehouseInventory ref="warehouseInventoryRef" @close="close" />
    <receivables ref="receivablesRef" @close="close"></receivables>
    <billManagement ref="billManagementRef" @close="close"></billManagement>
    <constructionPersonnel ref="ConstructionPersonnelRef" @close="close" />
    <customTrackNum ref="CustomTrackNumRef" @close="close" />
    <materialControl ref="CustomMaterialControlRef" @close="close" />
    <projectDepartmentAssessment ref="CustomProjectDepartmentAssessmentControlRef" @close="close"></projectDepartmentAssessment>
    <customCostPayRatioControl ref="CustomCostPayRatioControlRef" @close="close" />
  </div>
</template>

<script>
import EipUserSelector from '@/components/dialog/HtDialog/EipUserSelector'
import projectTaxes from './projectTaxes'
import designTaxes from './designTaxes'
import billManagement from './billManagement'
import warehouseInventory from './warehouseInventory'
import receivables from './receivables'
import constructionPersonnel from './constructionPersonnel'
import customTrackNum from './customTrackNum.vue'
import customCostPayRatioControl from './customCostPayRatioControl.vue'
import materialControl from './materialControl.vue'
import projectDepartmentAssessment from './projectDepartmentAssessment.vue'
import { mapState } from 'vuex'
import utils from '@/utils'

export default {
  name: 'businessRulesSwitch',
  components: {
    EipUserSelector,
    receivables,
    projectTaxes,
    designTaxes,
    billManagement,
    warehouseInventory,
    constructionPersonnel,
    customTrackNum,
    customCostPayRatioControl,
    projectDepartmentAssessment,
    materialControl
  },
  computed: {
    ...mapState({
      allDataDict: (state) => state.user.allDataDict,
      allEnumerate: (state) => state.user.allEnumerate
    })
  },
  data() {
    return {
      budget_manager: [],
      rows: {},
      noticeData: {},
      tree_data: [],
      dialogVisible: false,
      pageResult: {
        page: 1,
        pageSize: 20,
        total: 1
      },
      params: {},
      // 功能名称
      gnData: [
        {
          name: '联营协议'
        },
        {
          name: '联营垫资'
        },
        {
          name: '联营保证金'
        },
        {
          name: '联营资金借调'
        }
      ],
      // 父子项目
      pcData: [
        {
          name: '内签合同'
        },
        {
          name: '内签合同划款'
        }
      ],
      isEdit: false,
      receIsEdit: false,
      receShow: false,
      receNoticeData: {},
      show: false,
      show1: false
    }
  },
  methods: {
    changeKey(row, column, cellValue) {
      return utils.getAllEnumerateAttr({
        innerKey: cellValue,
        typeKey: 'DataSwitchConfigTypeEnums',
        allData: this.allEnumerate
      })
    },
    loadData(param, cb) {
      this.$http
        .post('${portal}/portal/data_switch_config/query_new', param)
        .then((resp) => {
          let response = resp.data
          let arr = {
            custom: '客户'
          }
          response.rows.forEach((item) => {
            item.F_type_key = arr[item.type_key]
            item.F_desc = item.desc
            item.F_is_open = item.is_open == 0 ? false : true
            item.F_default_user = {
              res: item.default_user,
              value: item.default_user_ids
            }
          })
          this.budget_manager = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => {
          if (cb) cb()
        })
    },
    handleClose() {
      this.dialogVisible = false
    },
    switchClick(row) {
      let open = 0
      if (row.F_is_open) {
        open = 1
      } else {
        open = 0
      }
      this.$http
        .put('${portal}/portal/data_switch_config/update_status?typeKey=' + row.type_key + '&status=' + open)
        .then((resp) => {
          if (resp.data.state) {
            this.$message.success('操作成功')
            let arr = {
              pageBean: this.pageResult
            }
            this.loadData(arr)
          }
        })
        .catch((msg) => {
          let arr = {
            pageBean: this.pageResult
          }
          this.loadData(arr)
        })
    },
    valueChange(params, res) {
      if (this.params.res != params.res && params.res != res.default_user) {
        this.params = params
        const param = {
          default_user_ids: params.value,
          default_user: params.res,
          type_key: res.type_key,
          is_open: res.F_is_open ? '1' : '0'
        }
        this.$http.put('${portal}/portal/data_switch_config/update_default', param).then((resp) => {
          if (resp.data.state) {
            this.$message.success('操作成功')
            let arr = {
              pageBean: this.pageResult
            }
            this.loadData(arr)
          }
        })
      }
    },
    // 施工扣税规则设置
    customProjectTaxes(row) {
      this.$http.get('${portal}/portal/data_switch_config/' + row.id).then((resp) => {
        if (resp.data && resp.data.deductionRule) {
          let p = resp.data.deductionRule
          p.contract_no_sign_tax = p.contract_no_sign_tax.toString()
          p.yjzzs_allow_negative = p.yjzzs_allow_negative.toString()
          p.yjzzs_local_allow_negative = p.yjzzs_local_allow_negative.toString()
          this.noticeData = Object.assign({}, resp.data.deductionRule, {
            refId: row.id
          })
        } else {
          this.noticeData = Object.assign({}, { refId: row.id })
        }
        this.show = true
        this.$refs.projectTaxes.resetFields()
      })
    },
    //设计扣税规则设置
    customDesignTaxes(row) {
      this.$http.get('${portal}/portal/data_switch_config/' + row.id).then((resp) => {
        if (resp.data && resp.data.deductionRule) {
          let p = resp.data.deductionRule
          p.yjzzs_allow_negative = p.yjzzs_allow_negative.toString()
          this.noticeData = Object.assign({}, resp.data.deductionRule, {
            refId: row.id
          })
        } else {
          this.noticeData = Object.assign({}, { refId: row.id })
        }
        this.show1 = true
        this.$refs.designTaxes.resetFields()
      })
    },
    // 有权应收款优化（APP）
    customReceivables(row) {
      this.$refs.receivablesRef.getReceivableCalculation()
    },
    // 仓库存货核算
    customWarehouse(row) {
      this.$refs.warehouseInventoryRef.getDetail()
    },
    customBillManagement() {
      this.$refs.billManagementRef.getReceivableCalculation()
    },
    //施工人员动态必配职位编辑
    customConstructionPersonnel(row) {
      this.$refs.ConstructionPersonnelRef.getDetail(row.id)
    },
    //营销跟踪数控制
    customTrackNumFunc(row) {
      this.$refs.CustomTrackNumRef.getDetail(row.id)
    },
    //集采材料控制
    customMaterialControlFunc(row) {
      this.$refs.CustomMaterialControlRef.getDetail(row.id)
    },
    //集采材料控制
    customProjectDepartmentAssessmentControlFunc(row) {
      this.$refs.CustomProjectDepartmentAssessmentControlRef.getReceivableCalculation(row.id)
    },
    //集采材料控制
    customCostPayRatioControlFunc(row) {
      this.$refs.CustomCostPayRatioControlRef.getDetail(row.id)
    },
    //关闭新增弹窗
    close() {
      let params = { pageBean: { page: 1, pageSize: 20, total: 1 } }
      this.show = false
      this.show1 = false
      this.receShow = false
      this.loadData(params)
    }
  }
}
</script>

<style scoped>
/deep/.toolbar-panel {
  margin-bottom: 0 !important;
}
/deep/.common-tools {
  min-height: 20px !important;
}
</style>
